<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<a id="page5"></a>
<h1 class="fmh">Table of Contents</h1>
<p class="fig0"><img alt="Image" src="images/img.jpg"/></p>
<p class="toc"><a href="#/chap01">Chapter 1 — The Test Subject</a></p>
<p class="toc"><a href="#/chap02">Chapter 2 — The Village Witch</a></p>
<p class="toc"><span href="#/chap03" title="Link target outside of Sample">Chapter 3 — You Are Supposed To Be Scary</span></p>
<p class="toc"><span href="#/chap04" title="Link target outside of Sample">Chapter 4 — The Witch Creator</span></p>
<p class="toc"><span href="#/chap05" title="Link target outside of Sample">Chapter 5 — The Terror Of Ivanov</span></p>
<p class="toc"><span href="#/chap06" title="Link target outside of Sample">Chapter 6 — Trouble Personified</span></p>
<p class="toc"><span href="#/chap07" title="Link target outside of Sample">Chapter 7 — She Would Never!</span></p>
<p class="toc"><span href="#/chap08" title="Link target outside of Sample">Chapter 8 — A Witch? More Like A Demon From Hell</span></p>
<p class="toc"><span href="#/chap09" title="Link target outside of Sample">Chapter 9 — Meanwhile, Back At The Ranch</span></p>
<p class="toc"><span href="#/chap10" title="Link target outside of Sample">Chapter 10 — Whatever …. (Rolling Eyes)</span></p>
<p class="toc"><span href="#/chap11" title="Link target outside of Sample">Chapter 11 — Be Afraid, Be Very Afraid</span></p>
<p class="toc"><span href="#/chap12" title="Link target outside of Sample">Chapter 12 — Wolves And A Blizzard. This Is Russia After All</span></p>
<p class="toc"><span href="#/chap13" title="Link target outside of Sample">Chapter 13 — Letting The Cat Out Of The Bag</span></p>
<p class="toc"><span href="#/chap14" title="Link target outside of Sample">Chapter 14 — Cookies and Goggles</span></p>
<p class="toc"><span href="#/chap15" title="Link target outside of Sample">Chapter 15 — Home</span></p>
<p class="toc"><span href="#/chap16" title="Link target outside of Sample">Chapter 16 — Conclusion</span></p>
<p class="toc1"><span href="#/ack" title="Link target outside of Sample">Aknowledgments</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?7a6f9d1e